<template>
<div class="container-fluid pb-4 bg-light">

	<toolbar>
		<h2>Financial</h2>
	</toolbar>

	<div class="tiles-container">
		
		<router-link v-for="tile in filteredTileButtons" :to="tile.path" class="tile-button" :key="tile.path">
			<i class="fa fa-3x" :class="tile.icon"></i>
			
			<div class="tile-label">{{ tile.label }}</div>
			<i v-if="'iconSecondary' in tile" class="fa" :class="tile.iconSecondary"></i>
			<p v-if="'description' in tile && tile.description">{{tile.description}}</p>
		</router-link>
		
	</div>
</div>
</template>

<script>
import Toolbar from "@/layout_fragments/Toolbar"

export default {
	name: "FinancialMain",
	components: {
		Toolbar
	},
	data() {
		return {
			tileButtons: [
				{
					label: "Invoices",
					icon: "fa-file-invoice-dollar",
					path: "/financial/invoices",
					description: "All the invoices that have been issued",
					anyModulePerms: ["Service Quotes/Invoices","Job Invoices"]
				},
				{
					label: "Purchase Orders",
					icon: "fa-file-invoice",
					path: "/financial/purchase-orders",
					description: "All the purchase orders that have been generated",
					modulePermRequired: "Purchase Orders"
				},
				{
					label: "Expenses",
					icon: "fa-receipt",
					//iconSecondary: "fa-eye",
					description: "Review and list all expenses",
					path: "/expenses/review"
				},
				
				
				{
					label: "New Invoice",
					icon: "fa-file-invoice",
					iconSecondary: 'fa-plus',
					path: "/invoice/new/details",
					description: "Create a new invoice",
					anyModulePerms: ["Service Quotes/Invoices","Job Invoices"]
				},
				{
					label: "New Purchase Order",
					icon: "fa-file-invoice",
					iconSecondary: 'fa-plus',
					path: "/financial/purchase-orders/new",
					description: "Create a new purchase order",
					modulePermRequired: "Purchase Orders"
				},
				{
					label: "Submit New Expenses",
					icon: "fa-receipt",
					iconSecondary: "fa-plus",
					description: "Submit a batch of new expenses",
					path: "/expenses/submit-new"
				},/*,
				{
					label: "Project Holdbacks",
					icon: "fa-cubes",
					iconSecondary: "fa-file-invoice-dollar",
					path: "/financial/invoices",
					modulePermRequired: "Job Invoices"
				}
				*/
			]
		}
	},
	computed: {
		filteredTileButtons() {
			return this.filterNavForPerms(this.tileButtons)
		}
	}
}
</script>

<style type="text/css" scoped>
	.tiles-container {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		flex-direction: row;
		max-width: 1200px;
		margin: auto;
	}

	.tile-button {
		text-decoration: none;
		color: inherit;
		display: flex;
		flex-direction: column;
		text-align: center;
		border-radius: 10px;
		background-color: white;
		padding: 15px;
		margin: 5px;
		width: calc(33.3% - 10px);
		height: 200px;
		justify-content: center;
		box-shadow: 2px 2px 2px gray;
	}

	.tile-button:hover {
		border: 1px solid black;
	}

	.tile-button i {
		color: var(--brand-primary-color);
	}

	.tile-button * {
		margin-bottom: 10px;
	}

	.tile-label {
		font-weight: 600;
		font-size: 12pt;
	}

	.tile-button div {
	}

	@media (max-width: 1000px) {
		.tile-button {
			width: calc(50% - 10px);
		}
	}

	@media (max-width: 360px) {
		.tile-button {
			width: 100%;
		}
	}
</style>